import { createContext } from "react";
import { FireStoreMeasurement } from "types";

type MeasurementsFilter = (measurements: FireStoreMeasurement[]) => FireStoreMeasurement[];

const MeasurementsFilterContext = createContext<undefined | MeasurementsFilter>(undefined);

export default MeasurementsFilterContext;
